module.exports = __webpack_public_path__ + "static/img/r-2-4.ab8a09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/r-2-4.png
// module id = unB+
// module chunks = 0